import { Card, CardContent, Grid, Typography } from '@mui/material'

export function AdminOverviewBar({ deliveryStats, customerCount }) {
	const kpis = [
		{
			label: 'Measurements (24h)',
			value: deliveryStats?.recentMeasurements ?? 0,
			color: 'primary',
		},
		{
			label: 'Pending Deliveries',
			value: deliveryStats?.pendingDeliveries ?? 0,
			color: 'warning.main',
		},
		{
			label: 'Failed Deliveries',
			value: deliveryStats?.failedDeliveries ?? 0,
			color: 'error.main',
		},
		{
			label: 'Active Customers',
			value: customerCount,
			color: 'success.main',
		},
	]

	return (
		<Grid container spacing={3} sx={{ mb: 4 }}>
			{kpis.map((kpi) => (
				<Grid item xs={12} sm={6} md={3} key={kpi.label}>
					<Card variant="outlined">
						<CardContent sx={{ py: 2.5 }}>
							<Typography variant="h4" fontWeight="bold" color={kpi.color}>
								{kpi.value}
							</Typography>
							<Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
								{kpi.label}
							</Typography>
						</CardContent>
					</Card>
				</Grid>
			))}
		</Grid>
	)
}
